export default "__VITE_ASSET__Cfwwsgfb__"